import type { ContextTargetKindKey } from '../types/types';

/**
 * Create a "kind:key" string from a ContextTargetKindKey object.
 * @param kindKey - The kind/key object.
 * @returns A string in the format "kind:key".
 */
export function makeKindKeyStringFromKindKey(kindKey: ContextTargetKindKey): string {
  return `${kindKey.kind}:${kindKey.key}`;
}

/**
 * Create a "kind:key" string from separate kind and key values.
 * @param contextKind - The context kind.
 * @param key - The context key.
 * @returns A string in the format "kind:key".
 */
export function makeKindKeyStringFromProps(contextKind: string, key: string): string {
  return makeKindKeyStringFromKindKey({ kind: contextKind, key });
}
